// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json$BwaxAdmin = require("../../../../bwax-js/ml/utils/json.bs.js");
var ClientEnv = require("bwax/clientEnv");
var Plate$BwaxAdmin = require("../../../../bwax-js/ml/plate.bs.js");
var Cookies$BwaxAdmin = require("../../../../bwax-js/re/binding/Cookies.bs.js");
var Caml_js_exceptions = require("bs-platform/lib/js/caml_js_exceptions.js");
var Lang_eval$BwaxAdmin = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var UserHelper$BwaxAdmin = require("../../../../bwax-js/ml/lang/UserHelper.bs.js");
var File_upload$BwaxAdmin = require("../../utils/file_upload.bs.js");
var Query_builder$BwaxAdmin = require("../../../../bwax-js/ml/query/query_builder.bs.js");
var Query_commands$BwaxAdmin = require("../../../../bwax-js/ml/query/query_commands.bs.js");
var Runtime_common$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");
var Lang_mod_string$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/builtin/lang_mod_string.bs.js");
var Front_end_helper$BwaxAdmin = require("../../front_end_helper.bs.js");
var Widget_mod_misc_ui$BwaxAdmin = require("./widget_mod_misc_ui.bs.js");
var WechatHelper = require("bwax-ui/legacy/page/wechatHelper");

var module_name = "UI";

function src(param) {
  return "\n\nmodule UI;\n\nimport Element exposing (Rule, Element);\n\n-- commands:\n-- toast\ntype ToastType = INFO | ERROR | SUCCESS | WARNING | LOADING;\n\ntoast: String -> ToastType -> Int -> Cmd msg = external;\n\n-- \nscrollIntoView: String -> Cmd msg = external;\n\n--\naddInvisibleElement: String -> Cmd msg = external;\n\n\ngoto: String -> Cmd msg = external;\n\n-- given a URL, replace the current location.\nreplace: String -> Cmd msg = external;\n\ncopy: String -> Cmd msg = external;\n\nalert: a -> Cmd msg = external;\n\n\n-- what to do after logout, is decided at the page.\nlogout: msg -> Cmd msg = external;\n\n\n-- msg decorator:\nconfirm: \n  ~{ title: String, message: String, cancelText: String, okText: String\n   , onCancel: msg, onOk: msg! \n   } -> msg = external;\n\n\n\n--- get web env \ntype alias WebEnv = \n  { protocol: String\n  , host: String\n  , currentURLPath: String\n  , currentURL: String\n  , originalURL: String\n  , isSandbox: Bool\n  , isIOS: Bool\n  , isWeChat: Bool\n  , isMobile: Bool\n  }\n;\n\ngetWebEnv: (WebEnv -> msg) -> Cmd msg = external;\n\n\n-- download and upload\ndownloadURL: String -> Maybe String -> Cmd msg = external;\n\ndownload: File -> Maybe String -> Cmd msg = external;\n\nuploadFile: \n    LocalFile \n  -> ~{ isPrivate: Bool, uploadFor: String }\n  -> (File -> msg) \n  -> (String -> msg) \n  -> Cmd msg = external;\n\nuploadImage: \n    LocalFile \n  -> ~{ isPrivate: Bool, uploadFor: String }\n  -> (Image -> msg) \n  -> (String -> msg) \n  -> Cmd msg = external;\n\n\n-- helpers:\n-- isWeChat: () -> Bool = external;\n-- isMobile: () -> Bool = external;\n-- isIOS: () -> Bool = external;\n\n-- URL path without the host and \n-- 应该改用 cmd 版本\n-- cmd 版本支持 server rendering\n-- currentURLPath: () -> String = external;\n\n-- Full path\n-- currentURL: () -> String = external;\n\n\n-- 用于获取企业微信当前聊天窗口的外部联系人ID，暂时放在这里\ngetWxWorkExternalContactID: (Maybe String -> msg) -> Cmd msg = external;\n\n";
}

function fail(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        "UI." + (name + ": Invalid Arguments")
      ];
}

function unit_to_literal(proc, name) {
  var func = function (args) {
    if (args) {
      var match = args[0][0];
      if (typeof match === "number" && !(match !== 0 || args[1])) {
        return /* tuple */[
                /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [Curry._1(proc, /* () */0)]),
                /* No_term */0
              ];
      } else {
        return fail(name);
      }
    } else {
      return fail(name);
    }
  };
  return /* tuple */[
          /* V_native_fn */Caml_chrome_debugger.variant("V_native_fn", 4, [
              1,
              func,
              /* [] */0
            ]),
          /* No_term */0
        ];
}

function func(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_toast",
              args
            ]),
          /* No_term */0
        ];
}

function func$1(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_scrollIntoView",
              args
            ]),
          /* No_term */0
        ];
}

function func$2(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_addInvisibleElement",
              args
            ]),
          /* No_term */0
        ];
}

function func$3(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_goto",
              args
            ]),
          /* No_term */0
        ];
}

function func$4(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_replace",
              args
            ]),
          /* No_term */0
        ];
}

function func$5(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_copy",
              args
            ]),
          /* No_term */0
        ];
}

function func$6(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_alert",
              args
            ]),
          /* No_term */0
        ];
}

function func$7(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_logout",
              args
            ]),
          /* No_term */0
        ];
}

function func$8(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_getWebEnv",
              args
            ]),
          /* No_term */0
        ];
}

function func$9(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_downloadURL",
              args
            ]),
          /* No_term */0
        ];
}

function func$10(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_download",
              args
            ]),
          /* No_term */0
        ];
}

function func$11(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("addQueryParam");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
        return fail("addQueryParam");
      } else {
        var match$2 = args[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("addQueryParam");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || match$4.tag !== /* String */2) {
              return fail("addQueryParam");
            } else {
              var match$5 = match$2[1];
              if (match$5) {
                var match$6 = match$5[0][0];
                if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                  return fail("addQueryParam");
                } else {
                  var match$7 = match$6[0];
                  if (typeof match$7 === "number" || !(match$7.tag === /* String */2 && !match$5[1])) {
                    return fail("addQueryParam");
                  } else {
                    return /* tuple */[
                            /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [Lang_mod_string$BwaxAdmin.addQueryParam(match$1[0], match$4[0], match$7[0])])]),
                            /* No_term */0
                          ];
                  }
                }
              } else {
                return fail("addQueryParam");
              }
            }
          }
        } else {
          return fail("addQueryParam");
        }
      }
    }
  } else {
    return fail("addQueryParam");
  }
}

function func$12(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("removeQueryParam");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
        return fail("removeQueryParam");
      } else {
        var match$2 = args[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("removeQueryParam");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
              return fail("removeQueryParam");
            } else {
              return /* tuple */[
                      /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [Lang_mod_string$BwaxAdmin.removeQueryParam(match$1[0], match$4[0])])]),
                      /* No_term */0
                    ];
            }
          }
        } else {
          return fail("removeQueryParam");
        }
      }
    }
  } else {
    return fail("removeQueryParam");
  }
}

function func$13(args) {
  return /* tuple */[
          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
              "Cmd_UI_getWxWorkExternalContactID",
              args
            ]),
          /* No_term */0
        ];
}

var externals_vals = Pervasives.$at(/* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "toast",
          Runtime_common$BwaxAdmin.pack_func(3, func)
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "scrollIntoView",
              Runtime_common$BwaxAdmin.pack_func(1, func$1)
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "addInvisibleElement",
                  Runtime_common$BwaxAdmin.pack_func(1, func$2)
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "goto",
                      Runtime_common$BwaxAdmin.pack_func(1, func$3)
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "replace",
                          Runtime_common$BwaxAdmin.pack_func(1, func$4)
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "copy",
                              Runtime_common$BwaxAdmin.pack_func(1, func$5)
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "alert",
                                  Runtime_common$BwaxAdmin.pack_func(1, func$6)
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "logout",
                                      Runtime_common$BwaxAdmin.pack_func(1, func$7)
                                    ],
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        /* tuple */[
                                          "confirm",
                                          Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                  if (param && !param[1]) {
                                                    return /* tuple */[
                                                            /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
                                                                "__ui_confirm__",
                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                    param[0],
                                                                    /* [] */0
                                                                  ])
                                                              ]),
                                                            Runtime_common$BwaxAdmin.nt
                                                          ];
                                                  } else {
                                                    return fail("confirm");
                                                  }
                                                }))
                                        ],
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            /* tuple */[
                                              "getWebEnv",
                                              Runtime_common$BwaxAdmin.pack_func(1, func$8)
                                            ],
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                /* tuple */[
                                                  "downloadURL",
                                                  Runtime_common$BwaxAdmin.pack_func(2, func$9)
                                                ],
                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                    /* tuple */[
                                                      "download",
                                                      Runtime_common$BwaxAdmin.pack_func(2, func$10)
                                                    ],
                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                        /* tuple */[
                                                          "uploadFile",
                                                          Runtime_common$BwaxAdmin.pack_func(4, (function (args) {
                                                                  return /* tuple */[
                                                                          /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
                                                                              "Cmd_UI_uploadFile",
                                                                              args
                                                                            ]),
                                                                          Runtime_common$BwaxAdmin.nt
                                                                        ];
                                                                }))
                                                        ],
                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                            /* tuple */[
                                                              "uploadImage",
                                                              Runtime_common$BwaxAdmin.pack_func(4, (function (args) {
                                                                      return /* tuple */[
                                                                              /* V_tagged */Caml_chrome_debugger.variant("V_tagged", 6, [
                                                                                  "Cmd_UI_uploadImage",
                                                                                  args
                                                                                ]),
                                                                              Runtime_common$BwaxAdmin.nt
                                                                            ];
                                                                    }))
                                                            ],
                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                /* tuple */[
                                                                  "isWeChat",
                                                                  unit_to_literal((function (param) {
                                                                          return /* Bool */Caml_chrome_debugger.variant("Bool", 4, [Front_end_helper$BwaxAdmin.isWeChat(/* () */0)]);
                                                                        }), "isWeChat")
                                                                ],
                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                    /* tuple */[
                                                                      "isMobile",
                                                                      unit_to_literal((function (param) {
                                                                              return /* Bool */Caml_chrome_debugger.variant("Bool", 4, [Front_end_helper$BwaxAdmin.isMobile(/* () */0)]);
                                                                            }), "isMobile")
                                                                    ],
                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        /* tuple */[
                                                                          "isIOS",
                                                                          unit_to_literal((function (param) {
                                                                                  return /* Bool */Caml_chrome_debugger.variant("Bool", 4, [Front_end_helper$BwaxAdmin.isIOS(/* () */0)]);
                                                                                }), "isIOS")
                                                                        ],
                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                            /* tuple */[
                                                                              "currentURL",
                                                                              unit_to_literal((function (param) {
                                                                                      return /* String */Caml_chrome_debugger.variant("String", 2, [Front_end_helper$BwaxAdmin.currentURL(/* () */0)]);
                                                                                    }), "currentURL")
                                                                            ],
                                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                /* tuple */[
                                                                                  "currentURLPath",
                                                                                  unit_to_literal((function (param) {
                                                                                          return /* String */Caml_chrome_debugger.variant("String", 2, [Front_end_helper$BwaxAdmin.currentURLPath(/* () */0)]);
                                                                                        }), "currentURLPath")
                                                                                ],
                                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                    /* tuple */[
                                                                                      "addQueryParam",
                                                                                      /* tuple */[
                                                                                        /* V_native_fn */Caml_chrome_debugger.variant("V_native_fn", 4, [
                                                                                            3,
                                                                                            func$11,
                                                                                            /* [] */0
                                                                                          ]),
                                                                                        Runtime_common$BwaxAdmin.nt
                                                                                      ]
                                                                                    ],
                                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                        /* tuple */[
                                                                                          "removeQueryParam",
                                                                                          /* tuple */[
                                                                                            /* V_native_fn */Caml_chrome_debugger.variant("V_native_fn", 4, [
                                                                                                2,
                                                                                                func$12,
                                                                                                /* [] */0
                                                                                              ]),
                                                                                            Runtime_common$BwaxAdmin.nt
                                                                                          ]
                                                                                        ],
                                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                            /* tuple */[
                                                                                              "getWxWorkExternalContactID",
                                                                                              Runtime_common$BwaxAdmin.pack_func(1, func$13)
                                                                                            ],
                                                                                            /* [] */0
                                                                                          ])
                                                                                      ])
                                                                                  ])
                                                                              ])
                                                                          ])
                                                                      ])
                                                                  ])
                                                              ])
                                                          ])
                                                      ])
                                                  ])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ]), Plate$BwaxAdmin.List.filter((function (param) {
              return Plate$BwaxAdmin.List.contains(param[0], /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            "newsflash",
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                "wechatLoginCode",
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    "onePageLayout001",
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        "swiper",
                                        /* [] */0
                                      ])
                                  ])
                              ])
                          ]));
            }))(Widget_mod_misc_ui$BwaxAdmin.externals_vals));

function ui_commands(context, param, on_trunk_msgs, _on_branch_msgs) {
  var cmd = param[0];
  if (typeof cmd === "number" || cmd.tag !== /* V_tagged */6) {
    return false;
  } else {
    switch (cmd[0]) {
      case "Cmd_UI_addInvisibleElement" :
          var match = cmd[1];
          if (match) {
            var match$1 = match[0][0];
            if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$2 = match$1[0];
              if (typeof match$2 === "number" || !(match$2.tag === /* String */2 && !match[1])) {
                return false;
              } else {
                Front_end_helper$BwaxAdmin.addInvisibleElement(match$2[0]);
                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                return true;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_alert" :
          var match$3 = cmd[1];
          if (match$3 && !match$3[1]) {
            Front_end_helper$BwaxAdmin.alert(Lang_eval$BwaxAdmin.string_of_value(match$3[0]));
            Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
            return true;
          } else {
            return false;
          }
      case "Cmd_UI_copy" :
          var match$4 = cmd[1];
          if (match$4) {
            var match$5 = match$4[0][0];
            if (typeof match$5 === "number" || match$5.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$6 = match$5[0];
              if (typeof match$6 === "number" || !(match$6.tag === /* String */2 && !match$4[1])) {
                return false;
              } else {
                Front_end_helper$BwaxAdmin.copy(match$6[0]);
                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                return true;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_download" :
          var match$7 = cmd[1];
          if (match$7) {
            var match$8 = match$7[0][0];
            if (typeof match$8 === "number" || !(match$8.tag === /* V_tagged_raw */8 && match$8[0] === "File")) {
              return false;
            } else {
              var match$9 = match$7[1];
              if (match$9 && !match$9[1]) {
                var match$10 = match$9[0][0];
                var mname;
                if (typeof match$10 === "number" || !(match$10.tag === /* V_tagged */6 && match$10[0] === "Just")) {
                  mname = undefined;
                } else {
                  var match$11 = match$10[1];
                  if (match$11) {
                    var match$12 = match$11[0][0];
                    if (typeof match$12 === "number" || match$12.tag !== /* V_literal */5) {
                      mname = undefined;
                    } else {
                      var match$13 = match$12[0];
                      mname = typeof match$13 === "number" || !(match$13.tag === /* String */2 && !match$11[1]) ? undefined : match$13[0];
                    }
                  } else {
                    mname = undefined;
                  }
                }
                Front_end_helper$BwaxAdmin.downloadFile(match$8[1], mname);
                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_downloadURL" :
          var match$14 = cmd[1];
          if (match$14) {
            var match$15 = match$14[0][0];
            if (typeof match$15 === "number" || match$15.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$16 = match$15[0];
              if (typeof match$16 === "number" || match$16.tag !== /* String */2) {
                return false;
              } else {
                var match$17 = match$14[1];
                if (match$17 && !match$17[1]) {
                  var match$18 = match$17[0][0];
                  var mname$1;
                  if (typeof match$18 === "number" || !(match$18.tag === /* V_tagged */6 && match$18[0] === "Just")) {
                    mname$1 = undefined;
                  } else {
                    var match$19 = match$18[1];
                    if (match$19) {
                      var match$20 = match$19[0][0];
                      if (typeof match$20 === "number" || match$20.tag !== /* V_literal */5) {
                        mname$1 = undefined;
                      } else {
                        var match$21 = match$20[0];
                        mname$1 = typeof match$21 === "number" || !(match$21.tag === /* String */2 && !match$19[1]) ? undefined : match$21[0];
                      }
                    } else {
                      mname$1 = undefined;
                    }
                  }
                  Front_end_helper$BwaxAdmin.downloadURL(match$16[0], mname$1);
                  Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                  return true;
                } else {
                  return false;
                }
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_getWebEnv" :
          var match$22 = cmd[1];
          if (match$22 && !match$22[1]) {
            var value = Runtime_common$BwaxAdmin.pack_object(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "protocol",
                      Runtime_common$BwaxAdmin.pack_string(context[/* web_env */9][/* protocol */0])
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "host",
                          Runtime_common$BwaxAdmin.pack_string(context[/* web_env */9][/* host */1])
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "currentURL",
                              Runtime_common$BwaxAdmin.pack_string(context[/* web_env */9][/* currentURL */2])
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "currentURLPath",
                                  Runtime_common$BwaxAdmin.pack_string(context[/* web_env */9][/* currentURLPath */3])
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "originalURL",
                                      Runtime_common$BwaxAdmin.pack_string(context[/* web_env */9][/* originalURL */4])
                                    ],
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        /* tuple */[
                                          "isSandbox",
                                          Runtime_common$BwaxAdmin.pack_bool(context[/* web_env */9][/* isSandbox */5])
                                        ],
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            /* tuple */[
                                              "isIOS",
                                              Runtime_common$BwaxAdmin.pack_bool(context[/* web_env */9][/* isIOS */6])
                                            ],
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                /* tuple */[
                                                  "isWeChat",
                                                  Runtime_common$BwaxAdmin.pack_bool(context[/* web_env */9][/* isWeChat */7])
                                                ],
                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                    /* tuple */[
                                                      "isMobile",
                                                      Runtime_common$BwaxAdmin.pack_bool(context[/* web_env */9][/* isMobile */8])
                                                    ],
                                                    /* [] */0
                                                  ])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ]));
            var msg = Lang_eval$BwaxAdmin.apply_value(undefined, match$22[0], value, Runtime_common$BwaxAdmin.nt);
            Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                        msg,
                        /* [] */0
                      ])]));
            return true;
          } else {
            return false;
          }
      case "Cmd_UI_getWxWorkExternalContactID" :
          var match$23 = cmd[1];
          if (match$23 && !match$23[1]) {
            var tagger = match$23[0];
            WechatHelper.getWxWorkExternalContactID(context[/* query_runner */4]).then((function (ms) {
                    var value = Runtime_common$BwaxAdmin.pack_maybe(Runtime_common$BwaxAdmin.pack_string, ms);
                    var msg = Lang_eval$BwaxAdmin.apply_value(undefined, tagger, value, Runtime_common$BwaxAdmin.nt);
                    Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                msg,
                                /* [] */0
                              ])]));
                    return Promise.resolve(/* () */0);
                  }));
            return true;
          } else {
            return false;
          }
      case "Cmd_UI_goto" :
          var match$24 = cmd[1];
          if (match$24) {
            var match$25 = match$24[0][0];
            if (typeof match$25 === "number" || match$25.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$26 = match$25[0];
              if (typeof match$26 === "number" || !(match$26.tag === /* String */2 && !match$24[1])) {
                return false;
              } else {
                Curry._2(context[/* route_to */8], match$26[0], false);
                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                return true;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_logout" :
          var match$27 = cmd[1];
          if (match$27 && !match$27[1]) {
            Front_end_helper$BwaxAdmin.logout(context[/* domain_env */7][/* tenantCode */3], context[/* domain_env */7][/* isSandbox */1]);
            Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                        match$27[0],
                        /* [] */0
                      ])]));
            return true;
          } else {
            return false;
          }
      case "Cmd_UI_replace" :
          var match$28 = cmd[1];
          if (match$28) {
            var match$29 = match$28[0][0];
            if (typeof match$29 === "number" || match$29.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$30 = match$29[0];
              if (typeof match$30 === "number" || !(match$30.tag === /* String */2 && !match$28[1])) {
                return false;
              } else {
                Curry._2(context[/* route_to */8], match$30[0], true);
                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                return true;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_scrollIntoView" :
          var match$31 = cmd[1];
          if (match$31) {
            var match$32 = match$31[0][0];
            if (typeof match$32 === "number" || match$32.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$33 = match$32[0];
              if (typeof match$33 === "number" || !(match$33.tag === /* String */2 && !match$31[1])) {
                return false;
              } else {
                Front_end_helper$BwaxAdmin.scrollIntoView(match$33[0]);
                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                return true;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_toast" :
          var match$34 = cmd[1];
          if (match$34) {
            var match$35 = match$34[0][0];
            if (typeof match$35 === "number" || match$35.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$36 = match$35[0];
              if (typeof match$36 === "number" || match$36.tag !== /* String */2) {
                return false;
              } else {
                var match$37 = match$34[1];
                if (match$37) {
                  var match$38 = match$37[0][0];
                  if (typeof match$38 === "number" || !(match$38.tag === /* V_tagged */6 && !match$38[1])) {
                    return false;
                  } else {
                    var match$39 = match$37[1];
                    if (match$39) {
                      var match$40 = match$39[0][0];
                      if (typeof match$40 === "number" || match$40.tag !== /* V_literal */5) {
                        return false;
                      } else {
                        var match$41 = match$40[0];
                        if (typeof match$41 === "number" || match$41.tag || match$39[1]) {
                          return false;
                        } else {
                          Front_end_helper$BwaxAdmin.toast(match$36[0], match$38[0], match$41[0]);
                          Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* [] */0]));
                          return true;
                        }
                      }
                    } else {
                      return false;
                    }
                  }
                } else {
                  return false;
                }
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_uploadFile" :
          var match$42 = cmd[1];
          if (match$42) {
            var match$43 = match$42[0][0];
            if (typeof match$43 === "number" || !(match$43.tag === /* V_tagged_raw */8 && match$43[0] === "LocalFile")) {
              return false;
            } else {
              var match$44 = match$42[1];
              if (match$44) {
                var match$45 = match$44[0][0];
                if (typeof match$45 === "number" || match$45.tag !== /* V_record */2) {
                  return false;
                } else {
                  var match$46 = match$44[1];
                  if (match$46) {
                    var match$47 = match$46[1];
                    if (match$47 && !match$47[1]) {
                      var error_tagger = match$47[0];
                      var data_tagger = match$46[0];
                      var config = match$45[0];
                      var match$48 = Plate$BwaxAdmin.List.assoc("isPrivate", config);
                      var $$public;
                      if (match$48 !== undefined) {
                        var match$49 = match$48[0];
                        if (typeof match$49 === "number" || match$49.tag !== /* V_literal */5) {
                          $$public = true;
                        } else {
                          var match$50 = match$49[0];
                          $$public = typeof match$50 === "number" || match$50.tag !== /* Bool */4 ? true : !match$50[0];
                        }
                      } else {
                        $$public = true;
                      }
                      var match$51 = Plate$BwaxAdmin.List.assoc("uploadFor", config);
                      var uploadFor;
                      if (match$51 !== undefined) {
                        var match$52 = match$51[0];
                        if (typeof match$52 === "number" || match$52.tag !== /* V_literal */5) {
                          uploadFor = undefined;
                        } else {
                          var match$53 = match$52[0];
                          uploadFor = typeof match$53 === "number" || match$53.tag !== /* String */2 ? undefined : match$53[0];
                        }
                      } else {
                        uploadFor = undefined;
                      }
                      var tag_error = function (message) {
                        return Lang_eval$BwaxAdmin.apply_value(undefined, error_tagger, /* tuple */[
                                    /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [message])]),
                                    Runtime_common$BwaxAdmin.nt
                                  ], Runtime_common$BwaxAdmin.nt);
                      };
                      File_upload$BwaxAdmin.upload_file(context[/* query_runner */4], match$43[1], $$public, uploadFor, false).then((function (param) {
                              var maybeFile = param[0];
                              if (maybeFile !== undefined) {
                                var msg = Lang_eval$BwaxAdmin.apply_value(undefined, data_tagger, /* tuple */[
                                      /* V_tagged_raw */Caml_chrome_debugger.variant("V_tagged_raw", 8, [
                                          "File",
                                          Caml_option.valFromOption(maybeFile)
                                        ]),
                                      Runtime_common$BwaxAdmin.nt
                                    ], Runtime_common$BwaxAdmin.nt);
                                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            msg,
                                            /* [] */0
                                          ])]));
                              } else {
                                var msg$1 = tag_error("上传出错");
                                Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            msg$1,
                                            /* [] */0
                                          ])]));
                              }
                              return Promise.resolve(/* () */0);
                            }));
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    return false;
                  }
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
      case "Cmd_UI_uploadImage" :
          var match$54 = cmd[1];
          if (match$54) {
            var match$55 = match$54[0][0];
            if (typeof match$55 === "number" || !(match$55.tag === /* V_tagged_raw */8 && match$55[0] === "LocalFile")) {
              return false;
            } else {
              var match$56 = match$54[1];
              if (match$56) {
                var match$57 = match$56[0][0];
                if (typeof match$57 === "number" || match$57.tag !== /* V_record */2) {
                  return false;
                } else {
                  var match$58 = match$56[1];
                  if (match$58) {
                    var match$59 = match$58[1];
                    if (match$59 && !match$59[1]) {
                      var error_tagger$1 = match$59[0];
                      var data_tagger$1 = match$58[0];
                      var config$1 = match$57[0];
                      var localFile = match$55[1];
                      var match$60 = Plate$BwaxAdmin.List.assoc("isPrivate", config$1);
                      var $$public$1;
                      if (match$60 !== undefined) {
                        var match$61 = match$60[0];
                        if (typeof match$61 === "number" || match$61.tag !== /* V_literal */5) {
                          $$public$1 = true;
                        } else {
                          var match$62 = match$61[0];
                          $$public$1 = typeof match$62 === "number" || match$62.tag !== /* Bool */4 ? true : !match$62[0];
                        }
                      } else {
                        $$public$1 = true;
                      }
                      var match$63 = Plate$BwaxAdmin.List.assoc("uploadFor", config$1);
                      var uploadFor$1;
                      if (match$63 !== undefined) {
                        var match$64 = match$63[0];
                        if (typeof match$64 === "number" || match$64.tag !== /* V_literal */5) {
                          uploadFor$1 = undefined;
                        } else {
                          var match$65 = match$64[0];
                          uploadFor$1 = typeof match$65 === "number" || match$65.tag !== /* String */2 ? undefined : match$65[0];
                        }
                      } else {
                        uploadFor$1 = undefined;
                      }
                      var match$66 = Json$BwaxAdmin.get_value("type", Js_json.decodeString, localFile);
                      var is_image = match$66 !== undefined ? Plate$BwaxAdmin.Str.contains("image", match$66) : false;
                      var tag_error$1 = function (message) {
                        return Lang_eval$BwaxAdmin.apply_value(undefined, error_tagger$1, /* tuple */[
                                    /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [message])]),
                                    Runtime_common$BwaxAdmin.nt
                                  ], Runtime_common$BwaxAdmin.nt);
                      };
                      if (is_image) {
                        File_upload$BwaxAdmin.upload_file(context[/* query_runner */4], localFile, $$public$1, uploadFor$1, false).then((function (param) {
                                var maybeFile = param[0];
                                if (maybeFile !== undefined) {
                                  var msg = Lang_eval$BwaxAdmin.apply_value(undefined, data_tagger$1, /* tuple */[
                                        /* V_tagged_raw */Caml_chrome_debugger.variant("V_tagged_raw", 8, [
                                            "Image",
                                            Caml_option.valFromOption(maybeFile)
                                          ]),
                                        Runtime_common$BwaxAdmin.nt
                                      ], Runtime_common$BwaxAdmin.nt);
                                  Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                              msg,
                                              /* [] */0
                                            ])]));
                                } else {
                                  var msg$1 = tag_error$1("上传出错");
                                  Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                              msg$1,
                                              /* [] */0
                                            ])]));
                                }
                                return Promise.resolve(/* () */0);
                              }));
                        return true;
                      } else {
                        var msg$1 = tag_error$1("上传的文件不是图片");
                        Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    msg$1,
                                    /* [] */0
                                  ])]));
                        return true;
                      }
                    } else {
                      return false;
                    }
                  } else {
                    return false;
                  }
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
      default:
        return false;
    }
  }
}

function handle_user_cmd(context, param, on_trunk_msgs, _on_branch_msgs) {
  var dts = context[/* dts */2];
  var cmd = param[0];
  var query_context = Query_builder$BwaxAdmin.runtime_to_query_context(context);
  if (typeof cmd === "number" || cmd.tag !== /* V_tagged */6) {
    return false;
  } else {
    switch (cmd[0]) {
      case "Cmd_Query_nice_to_have_current_user" :
          var match = cmd[1];
          if (match) {
            var match$1 = match[1];
            if (match$1 && !match$1[1]) {
              var data_tagger = match[0];
              try {
                var match$2 = Query_commands$BwaxAdmin.get_binds(dts, data_tagger);
                var selection = Query_commands$BwaxAdmin.to_selection(match$2[1]);
                var query = /* Q_get_current_user */Caml_chrome_debugger.variant("Q_get_current_user", 5, [selection]);
                Query_builder$BwaxAdmin.resolve_and_run_queries(query_context, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        query,
                        /* [] */0
                      ]), /* record */Caml_chrome_debugger.record([
                        "force_refreshing",
                        "process_select_value",
                        "process_composite_data",
                        "additional_query_params"
                      ], [
                        false,
                        true,
                        true,
                        0
                      ]), (function (param) {
                        if (param.tag) {
                          return Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [param[0]]));
                        } else {
                          var match = param[0];
                          if (match && !match[1]) {
                            var user = match[0][0];
                            if (user !== undefined) {
                              var msg = Lang_eval$BwaxAdmin.apply_value(undefined, data_tagger, Runtime_common$BwaxAdmin.pack_just(user), Runtime_common$BwaxAdmin.nt);
                              return Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                msg,
                                                /* [] */0
                                              ])]));
                            } else {
                              if (ClientEnv.isWeChat()) {
                                Front_end_helper$BwaxAdmin.gotoWechatLogin(context[/* domain_env */7][/* isSandbox */1], context[/* domain_env */7][/* tenantCode */3]);
                              } else {
                                console.log("No user but that's okay");
                              }
                              var msg$1 = Lang_eval$BwaxAdmin.apply_value(undefined, data_tagger, Runtime_common$BwaxAdmin.pack_nothing, Runtime_common$BwaxAdmin.nt);
                              return Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                msg$1,
                                                /* [] */0
                                              ])]));
                            }
                          } else {
                            return Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [[
                                            Runtime_common$BwaxAdmin.Runtime_exn,
                                            "Unexpected result"
                                          ]]));
                          }
                        }
                      }));
              }
              catch (raw_e){
                var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [e]));
              }
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
      case "Cmd_Query_requestAuthSession" :
          var match$3 = cmd[1];
          if (match$3) {
            var match$4 = match$3[0][0];
            if (typeof match$4 === "number" || match$4.tag !== /* V_literal */5) {
              return false;
            } else {
              var match$5 = match$4[0];
              if (typeof match$5 === "number" || match$5.tag !== /* String */2) {
                return false;
              } else {
                var match$6 = match$3[1];
                if (match$6 && !match$6[1]) {
                  var result_tagger = match$6[0];
                  UserHelper$BwaxAdmin.requestSessionToken(context[/* query_runner */4], match$5[0]).then((function (token) {
                          Query_builder$BwaxAdmin.clear_cache(query_context);
                          Cookies$BwaxAdmin.set("X-SessionToken", token, /* record */Caml_chrome_debugger.record([
                                  "expires",
                                  "path",
                                  "domain"
                                ], [
                                  100,
                                  "/",
                                  undefined
                                ]));
                          var msg = Lang_eval$BwaxAdmin.apply_value(undefined, result_tagger, Runtime_common$BwaxAdmin.pack_bool(true), Runtime_common$BwaxAdmin.nt);
                          Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                      msg,
                                      /* [] */0
                                    ])]));
                          return Promise.resolve(/* () */0);
                        }));
                  return true;
                } else {
                  return false;
                }
              }
            }
          } else {
            return false;
          }
      case "Cmd_Query_requireUser" :
          var match$7 = cmd[1];
          if (match$7) {
            var match$8 = match$7[1];
            if (match$8) {
              var match$9 = match$8[1];
              if (match$9 && !match$9[1]) {
                var error_tagger = match$9[0];
                var data_tagger$1 = match$8[0];
                var maybe_login_url = match$7[0];
                try {
                  var match$10 = Query_commands$BwaxAdmin.get_direct_bind(dts, data_tagger$1);
                  var selection$1 = Query_commands$BwaxAdmin.to_selection(match$10[1]);
                  var query$1 = /* Q_get_current_user */Caml_chrome_debugger.variant("Q_get_current_user", 5, [selection$1]);
                  Query_builder$BwaxAdmin.resolve_and_run_queries(query_context, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                          query$1,
                          /* [] */0
                        ]), /* record */Caml_chrome_debugger.record([
                          "force_refreshing",
                          "process_select_value",
                          "process_composite_data",
                          "additional_query_params"
                        ], [
                          false,
                          true,
                          true,
                          0
                        ]), (function (param) {
                          if (param.tag) {
                            return Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [param[0]]));
                          } else {
                            var match = param[0];
                            if (match && !match[1]) {
                              var user = match[0][0];
                              if (user !== undefined) {
                                var msg = Lang_eval$BwaxAdmin.apply_value(undefined, data_tagger$1, user, Runtime_common$BwaxAdmin.nt);
                                return Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                  msg,
                                                  /* [] */0
                                                ])]));
                              } else {
                                var login_url = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Lang_eval$BwaxAdmin.as_option(maybe_login_url));
                                Front_end_helper$BwaxAdmin.gotoLoginUrlOrWechatLogin(login_url, context[/* route_to */8], undefined, context[/* domain_env */7][/* isSandbox */1], context[/* domain_env */7][/* tenantCode */3]);
                                var msg$1 = Lang_eval$BwaxAdmin.apply_value(undefined, error_tagger, /* tuple */[
                                      /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, ["尝试登录"])]),
                                      Runtime_common$BwaxAdmin.nt
                                    ], Runtime_common$BwaxAdmin.nt);
                                return Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                  msg$1,
                                                  /* [] */0
                                                ])]));
                              }
                            } else {
                              return Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [[
                                              Runtime_common$BwaxAdmin.Runtime_exn,
                                              "Unexpected result"
                                            ]]));
                            }
                          }
                        }));
                }
                catch (raw_e$1){
                  var e$1 = Caml_js_exceptions.internalToOCamlException(raw_e$1);
                  Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [e$1]));
                }
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else {
            return false;
          }
      case "Cmd_Query_require_current_user" :
          var match$11 = cmd[1];
          if (match$11) {
            var match$12 = match$11[1];
            if (match$12 && !match$12[1]) {
              var error_tagger$1 = match$12[0];
              var data_tagger$2 = match$11[0];
              try {
                var match$13 = Query_commands$BwaxAdmin.get_direct_bind(dts, data_tagger$2);
                var selection$2 = Query_commands$BwaxAdmin.to_selection(match$13[1]);
                var query$2 = /* Q_get_current_user */Caml_chrome_debugger.variant("Q_get_current_user", 5, [selection$2]);
                Query_builder$BwaxAdmin.resolve_and_run_queries(query_context, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        query$2,
                        /* [] */0
                      ]), /* record */Caml_chrome_debugger.record([
                        "force_refreshing",
                        "process_select_value",
                        "process_composite_data",
                        "additional_query_params"
                      ], [
                        false,
                        true,
                        true,
                        0
                      ]), (function (param) {
                        if (param.tag) {
                          return Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [param[0]]));
                        } else {
                          var match = param[0];
                          if (match && !match[1]) {
                            var user = match[0][0];
                            if (user !== undefined) {
                              var msg = Lang_eval$BwaxAdmin.apply_value(undefined, data_tagger$2, user, Runtime_common$BwaxAdmin.nt);
                              return Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                msg,
                                                /* [] */0
                                              ])]));
                            } else {
                              Front_end_helper$BwaxAdmin.gotoWechatLogin(context[/* domain_env */7][/* isSandbox */1], context[/* domain_env */7][/* tenantCode */3]);
                              var msg$1 = Lang_eval$BwaxAdmin.apply_value(undefined, error_tagger$1, /* tuple */[
                                    /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, ["微信登录"])]),
                                    Runtime_common$BwaxAdmin.nt
                                  ], Runtime_common$BwaxAdmin.nt);
                              return Curry._1(on_trunk_msgs, /* Ok */Caml_chrome_debugger.variant("Ok", 0, [/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                msg$1,
                                                /* [] */0
                                              ])]));
                            }
                          } else {
                            return Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [[
                                            Runtime_common$BwaxAdmin.Runtime_exn,
                                            "Unexpected result"
                                          ]]));
                          }
                        }
                      }));
              }
              catch (raw_e$2){
                var e$2 = Caml_js_exceptions.internalToOCamlException(raw_e$2);
                Curry._1(on_trunk_msgs, /* Error */Caml_chrome_debugger.variant("Error", 1, [e$2]));
              }
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
      default:
        return false;
    }
  }
}

var command_handlers_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    handle_user_cmd,
    /* [] */0
  ]);

var command_handlers = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    ui_commands,
    command_handlers_001
  ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

exports.module_name = module_name;
exports.src = src;
exports.fail = fail;
exports.unit_to_literal = unit_to_literal;
exports.externals_vals = externals_vals;
exports.ui_commands = ui_commands;
exports.handle_user_cmd = handle_user_cmd;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* externals_vals Not a pure module */
